module.exports = "<form class=\"{{formClass}}\" (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" novalidate role=\"form\">\n    <appc-dynamic-control *ngFor=\"let ctrl of controls\" [control]=\"ctrl\" [form]=\"form\"></appc-dynamic-control>\n\n    <button type=\"submit\" class=\"btn btn-primary pull-right\" [disabled]=\"!form.valid\">{{btnText}}</button>\n</form>"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/forms/dynamic-form.component.html
// module id = ../../../../../src/app/shared/forms/dynamic-form.component.html
// module chunks = main